import React from 'react';

export const App = React.lazy(() =>
  import(
    /* webpackPreload: true, webpackChunkName: "app" */
    './App'
  ),
);

export { AppError } from './Error';
export { AppLoading } from './Loading';
